import { axiosClient } from '@/shared/apis/config';
import { ApiResponse } from '@/shared/types';
import type { GetFolderHierarchyRequestType } from '@/shared/types/folder';
import type { GetFolderHierarchyWithSharedResponseType } from '@/shared/types/folder';
import { CustomQueryOptions } from '@/shared/types/global/react-query/query';
import { useQuery } from '@tanstack/react-query';

type GetFolderHierarchyWithSharedResponse =
  ApiResponse<GetFolderHierarchyWithSharedResponseType>;

export const getFolderHierarchyWithSharedApi = async ({
  spaceId,
}: GetFolderHierarchyRequestType) => {
  try {
    const response =
      await axiosClient.get<GetFolderHierarchyWithSharedResponse>(
        '/v2.0/folder/hierarchy',
        {
          params: { spaceId },
        },
      );
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const QueryKeyUseGetFolderHierarchyWithSharedApi =
  'folderHierarchyWithShared' as const;

export const useGetFolderHierarchyWithSharedApi = (
  { spaceId }: GetFolderHierarchyRequestType,
  options?: CustomQueryOptions<GetFolderHierarchyWithSharedResponse>,
) => {
  const { queryKey, ...rest } = options ?? {};

  return useQuery({
    queryKey: [
      QueryKeyUseGetFolderHierarchyWithSharedApi,
      spaceId,
      ...(queryKey ?? []),
    ],
    queryFn: async () => await getFolderHierarchyWithSharedApi({ spaceId }),
    ...rest,
  });
};
